(function () {
  'use strict';
  if (window.__cxPdpProofRuntime) return;
  window.__cxPdpProofRuntime = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalize(text) {
    return (text || '').toLowerCase();
  }

  function insertAfter(anchor, node) {
    if (!anchor || !anchor.parentNode) return false;
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
    return true;
  }

  function replaceStaleReturnCopy() {
    var stale = ['Returns accepted within 45 days', 'no restock fees or return label fee.'].join(', ');
    var fresh = 'Returns accepted within 45 days.';
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (node.nodeValue && node.nodeValue.indexOf(stale) !== -1) {
        node.nodeValue = node.nodeValue.replace(stale, fresh);
      }
    });
  }


  function hideDescriptionFallbackIfServerProof() {
    var serverProof = document.querySelector('.product__info-container .cx-pdp-proof');
    if (!serverProof) return;
    var fallbacks = document.querySelectorAll('[data-chaosrx-premium-proof], [data-chaosrx-premium-compare]');
    fallbacks.forEach(function (node) {
      node.style.display = 'none';
    });
  }

  function buildBadges(title, pageText) {
    var titleText = normalize(title);
    var bodyText = normalize(pageText);
    var joined = titleText + ' ' + bodyText;
    var badges = [];
    var seen = {};

    function add(label) {
      if (!seen[label]) {
        seen[label] = true;
        badges.push(label);
      }
    }

    var flagship = /ballistic m frame|radar ev s path|wiley x apex|smith arena elite/.test(titleText);
    if (flagship) add('Flagship');
    if (flagship || /oakley|wiley x|smith/.test(titleText)) add('Pro');
    if (/ballistic|mil-prf|m frame/.test(joined)) add('Ballistic');
    if (/z87|ansi/.test(joined)) add('ANSI Z87.1+');
    if (/prizm/.test(joined)) add('PRIZM');
    if (/polarized/.test(joined)) add('Polarized');
    if (/polycarbonate|plutonite|z87|ansi/.test(joined)) add('Polycarbonate lens');

    if (!badges.length) {
      add('Authorized dealer');
      add('Fast US shipping');
    }
    return badges.slice(0, 7);
  }

  function buildProof(title, pageText) {
    var badges = buildBadges(title, pageText);
    var hasZ87 = /z87|ansi/.test(normalize(title + ' ' + pageText));
    var hasBallistic = /ballistic|mil-prf|m frame/.test(normalize(title + ' ' + pageText));
    var hasLensTech = /prizm/.test(normalize(title + ' ' + pageText));
    var wrap = document.createElement('div');
    wrap.className = 'cx-pdp-proof cx-pdp-proof--runtime';
    wrap.setAttribute('aria-label', 'Product proof and shipping details');

    var badgeHtml = badges.map(function (label) {
      return '<span class="cx-spec-badge">' + label + '</span>';
    }).join('');

    var list = [];
    if (hasZ87) list.push('Impact-rated safety option with ANSI Z87.1+ proof where marked.');
    if (hasBallistic) list.push('Ballistic-grade option for range, field, and high-impact work use.');
    if (hasLensTech) list.push('Lens tech: Oakley PRIZM where selected.');
    if (hasZ87 || hasBallistic) list.push('Polycarbonate lens material for jobsite impact protection.');
    if (hasZ87) list.push('Cross-brand Z87+ guidance for work crews, shops, and anyone comparing Heat Wave, Wiley X, Oakley, Smith, Spy, and Wye/Delta in one place.');
    list.push('In-stock items ship fast from Phoenix with secure checkout.');

    wrap.innerHTML = [
      '<div class="cx-spec-badges cx-spec-badges--pdp">' + badgeHtml + '</div>',
      '<div class="cx-pdp-proof__trust">',
      '<span>Authorized dealer</span>',
      '<span>Free US shipping</span>',
      '<span>45-day returns</span>',
      '<span>Manufacturer warranty</span>',
      '</div>',
      '<ul class="cx-pdp-proof__list">' + list.map(function (item) { return '<li>' + item + '</li>'; }).join('') + '</ul>'
    ].join('');
    return wrap;
  }

  function isPremiumTitle(title) {
    return /ballistic m frame|radar ev s path|wiley x apex|smith arena elite|m frame|radar ev|flak 2\.0/.test(normalize(title));
  }

  function buildCompare(currentTitle) {
    var products = [
      {
        handle: 'oakley-ballistic-m-frame-3-0',
        title: 'Oakley Ballistic M Frame 3.0',
        vendor: 'Oakley',
        price: '$175',
        image: 'https://cdn.shopify.com/s/files/1/0622/3154/3975/files/oakley-ballistic-m-frame-3-0-cxsq.jpg?v=1780458765',
        badges: 'Ballistic, ANSI Z87.1+'
      },
      {
        handle: 'oakley-radar-ev-s-path',
        title: 'Oakley Radar EV S Path',
        vendor: 'Oakley',
        price: '$244',
        image: 'https://cdn.shopify.com/s/files/1/0622/3154/3975/files/oakley-radar-ev-s-path-cxsq.jpg?v=1780460443',
        badges: 'Small fit, PRIZM'
      },
      {
        handle: 'wiley-x-apex-z87',
        title: 'Wiley X Apex Z87',
        vendor: 'Wiley X',
        price: '$243',
        image: 'https://cdn.shopify.com/s/files/1/0622/3154/3975/files/wiley-x-apex-z87-cxsq.jpg?v=1780460257',
        badges: 'ANSI Z87.1+, premium'
      },
      {
        handle: 'smith-arena-elite-z87',
        title: 'Smith Arena Elite Z87',
        vendor: 'Smith Optics',
        price: '$185',
        image: 'https://cdn.shopify.com/s/files/1/0622/3154/3975/files/smith-arena-elite-z87-cxsq.jpg?v=1780460315',
        badges: 'ANSI Z87.1+, premium'
      }
    ];
    var current = normalize(currentTitle);
    var wrap = document.createElement('div');
    wrap.className = 'cx-premium-compare cx-premium-compare--runtime';
    wrap.setAttribute('aria-label', 'Compare premium safety eyewear');
    wrap.innerHTML = [
      '<div class="cx-premium-compare__head"><span>Compare premium picks</span><a href="/collections/z87-safety-sunglasses?sort_by=price-descending">Shop high to low</a></div>',
      '<div class="cx-premium-compare__grid">',
      products.map(function (item) {
        var active = current.indexOf(normalize(item.title).replace(' z87', '')) !== -1 || current.indexOf(normalize(item.handle).replace(/-/g, ' ')) !== -1;
        return [
          '<a class="cx-premium-compare__card' + (active ? ' is-current' : '') + '" href="/products/' + item.handle + '">',
          '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="90" height="90">',
          '<span class="cx-premium-compare__body">',
          '<strong>' + item.title + '</strong>',
          '<small>' + item.vendor + ' · ' + item.price + '</small>',
          '<span class="cx-spec-badges cx-spec-badges--mini"><span class="cx-spec-badge">' + item.badges.split(', ')[0] + '</span><span class="cx-spec-badge">' + item.badges.split(', ')[1] + '</span></span>',
          '</span>',
          '</a>'
        ].join('');
      }).join(''),
      '</div>'
    ].join('');
    return wrap;
  }

  ready(function () {
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;

    replaceStaleReturnCopy();
    hideDescriptionFallbackIfServerProof();

    var info = document.querySelector('.product__info-container') || document.querySelector('product-info');
    if (!info) return;
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('h1');
    var title = titleEl ? titleEl.textContent.trim() : document.title;
    var pageText = document.body.textContent || '';

    if (!document.querySelector('.cx-pdp-proof')) {
      var price = info.querySelector('[id^="price-"]') || info.querySelector('.price') || info;
      insertAfter(price, buildProof(title, pageText));
    }

    if (!document.querySelector('.cx-premium-compare') && isPremiumTitle(title)) {
      var formAnchor = info.querySelector('product-form') || info.querySelector('.product-form') || info.querySelector('form[action*="/cart/add"]');
      if (!formAnchor) formAnchor = document.querySelector('product-form') || document.querySelector('.product-form');
      if (!insertAfter(formAnchor, buildCompare(title))) {
        info.appendChild(buildCompare(title));
      }
    }
  });
})();
